var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-view-list-field',{attrs:{"align":"center","demoted-icon":_vm.field.type,"is-sticky":_vm.isSticky,"is-demoted":_vm.isDemoted,"field":_vm.field,"filter":_vm.filter}},[(_vm.value !== false)?_c('core-progress',{attrs:{"percent":_vm.value}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }